// lib/validation-schemas.js
import * as z from "zod";

export const expertFormSchema = z.object({
  firstName: z.string().min(2, "First name must be at least 2 characters"),
  lastName: z.string().min(2, "Last name must be at least 2 characters"),
  email: z.string().email("Invalid email address"),
  phone: z.string().min(10, "Phone number must be at least 10 digits"),
  gender: z.string().min(1, "Gender is required"),
  country: z.string().min(1, "Country is required"),
  city: z.string().min(1, "City is required"),
  highestDegree: z.string().min(1, "Highest degree is required"),
  fieldOfStudy: z.string().min(1, "Field of study is required"),
  expertise: z.array(z.string()).min(1, "Select at least one expertise area"),
  skills: z.array(z.string()).min(1, "Select at least one skill"),
  arabicProficiency: z.string().min(1, "Arabic proficiency is required"),
  englishProficiency: z.string().min(1, "English proficiency is required"),
  digitalSkills: z.string().min(1, "Digital skills level is required"),
  experienceYears: z.string().min(1, "Experience years is required"),
  dailyRate: z.string().min(1, "Daily rate is required"),
  currency: z.string().min(1, "Currency is required"),
  canTravel: z.string().min(1, "Travel ability is required"),
  travelDetails: z.string().optional(),
  specificSkills: z.string().optional(),
  specificExpertise: z.string().optional(),
  cv: z.any().refine((file) => file, "CV is required")
});

export const registrationSchema = z.object({
  name: z.string().min(2, "Name must be at least 2 characters"),
  email: z.string().email("Invalid email address"),
  password: z.string().min(8, "Password must be at least 8 characters")
    .regex(/[A-Z]/, "Password must contain at least one uppercase letter")
    .regex(/[a-z]/, "Password must contain at least one lowercase letter")
    .regex(/[0-9]/, "Password must contain at least one number"),
});